export const blockIconsAlertNotificationImportant = (
	<span className='material-symbols-outlined'>notification_important</span>
);
